import styled from 'styled-components';

import agrmntSprite from './assets/agrmntSprite.png';

export const styledDiv = styled.div(
  props => `
  background: linear-gradient(0deg, rgba(255, 255, 255, 0) 72.33%, #DED1F4 111.55%);
  padding: 30px 14px 27px 30px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  width: 745px;
.selectTnCWrap .navigationSec {
    padding: 30px;
    width: 650px;
    background: none;
}
.expiryInfo {
    background: #FFEFDC;
    border-radius: 4px;
    padding: 4px 6px;
    color: #DC8319;
    font-weight: 700;
    margin-left: auto;
}
.stepTrack {
    color: rgba(0, 0, 0, 0.3);
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 20px;
}
.stepTrackBar {
    height: 4px;
    width: 100%;
    background: rgba(0, 145, 255, 0.3);
    border-radius: 10px;
}
.stepTrackBar.stepTrackBar3::after {
    content: '';
    height: 4px;
    background: #0091FF;
    border-radius: 10px;
    width: 85%;
    display: inline-block;
}
&.selectTnCWrap.navigationSec .heading {
    font-size: 28px;
    color: #000000;
    font-weight: 900;
    background: none;
    -webkit-text-fill-color: #000000;
}

&.selectTnCWrap .heading {
    font-size: 30px;
    font-weight: 900;
    line-height: 36px;
    background: linear-gradient(40.06deg, #45355C -10.19%, #765A9F 82.14%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

&.selectTnCWrap .subHeading {
    font-size: 14px;
    line-height: 22px;
    color: #000000;
    margin-top: 6px;
}
&.selectTnCWrap .selectTnC-content {
    display: flex;
    margin-top: 35px;
}
&.selectTnCWrap .selectTnC-content .exstngAgrmnt {
    margin-left: 10px;
    text-align: center;
}
&.selectTnCWrap .selectTnC-content .exstngAgrmnt .exstngAgrmnt-contnt {
    background: linear-gradient(180deg, #DFDFDF -16.26%, rgba(255, 255, 255, 0) 127.91%);
    border-radius: 4px;
    padding: 0 10px;
    text-align: center;
}
&.selectTnCWrap .selectTnC-content .newAgrmnt {
    margin-left: 17px;
    text-align: center;
    background: linear-gradient(0deg, #C9FEC5 -18.6%, rgba(255, 255, 255, 0) 124.8%);
    border: 0.5px solid #C44A3E;
    box-sizing: border-box;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 0 22px;
    position: relative;
}
&.selectTnCWrap .selectTnC-content .cardHeight {
    flex: 1;
}
&.selectTnCWrap .selectTnC-content .cardHeight p {
    padding: 17px 0 16px 0;
}
&.selectTnCWrap .selectTnC-content .equalHeight {
    padding: 20px 0 15px 0;
    font-size: 14px;
    font-weight: 700;
    color: #000000;
}
&.selectTnCWrap .selectTnC-content .benefits .equalHeight {
    border-bottom: 1px solid #DDDDDD;
    display: flex;
    align-items: flex-end;
}
.equalHeight0, .equalHeight1, .equalHeight2, .equalHeight3, .equalHeight4 {
    font-size: 14px;
    border-bottom: 1px solid #DDDDDD;
}

&.selectTnCWrap .selectTnC-content .exstngAgrmntBtn {
    font-size: 14px;
    font-weight: 500;
    color: #0091FF;
    width: 190px;
    padding: 15px;
    border-radius: 4px;
    text-align: center;
    border: 1px solid rgba(0, 145, 255, 1);
    margin: 22px 0 20px;
    cursor: pointer;
    background: #FFFFFF;
}
&.selectTnCWrap .primaryBtn {
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    background: linear-gradient(128.84deg, #53B2FE -13.7%, #065AF3 137.24%);
    box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    text-align: center;
    padding: 15px;
    width: 190px;
    border: none;
    cursor: pointer;
    margin-top: 0px;
}
&.selectTnCWrap .primaryBtn.newAgrmntBtn {
    margin: 22px 0 20px;
}

&.selectTnCWrap .selectTnC-content .newAgrmnt .infoTag {
    background: linear-gradient(73.1deg, #43E1A8 6.47%, #219393 95.01%);
    border-radius: 10px;
    font-size: 10px;
    font-weight: 700;
    color: #ffffff;
    padding: 2px 6px 3px;
    position: absolute;
    top: -8px;
    left: 22px;
}

&.selectTnCWrap .tertiaryBtn {
    font-size: 16px;
    color: #0091FF;
    line-height: 16px;
    margin: 0 30px 0 0;
    font-weight: 500;
    border: none;
    background: no-repeat;
    text-decoration: underline;
    cursor: pointer;
}
&.selectTnCWrap .selectExstngAgrmnt {
    height: 543px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 26px 95px 0px 92px;
}
&.selectTnCWrap .selectExstngAgrmnt .selectExstngAgrmnt-img {
    width: 130px;
    height: 103px;
    margin-bottom: 33px;
    margin-top: 33px
}
&.selectTnCWrap .selectExstngAgrmnt .selectExstngAgrmnt-title {
    font-size: 24px;
    line-height: 28px;
    font-weight: 900;
    color: #000000;
    text-align: center;
}
&.selectTnCWrap .selectExstngAgrmnt .selectExstngAgrmnt-subtitle {
  margin-top: 12px;
  font-size: 17px;
}
.selectExstngAgrmnt-subtitle {
  font-size: 20px !important;
}
&.selectTnCWrap .selectExstngAgrmnt .benefitsTitle {
    margin-top: 72px;
    font-size: 18px;
    line-height: 22px;
    color: #4a4a4a;
    text-align: center;
}
&.selectTnCWrap .selectExstngAgrmnt .selectExstngAgrmnt-benefits {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    gap: 20px;
    
}
&.selectTnCWrap .selectExstngAgrmnt .selectExstngAgrmnt-benefits-text {
  margin-bottom: 30px;
  margin-top: 10px;
}
&.selectTnCWrap .selectExstngAgrmnt .selectExstngAgrmnt-benefits li {
    display: flex;
    align-items: center;
    margin-right: 30px;
    //max-width: 165px;
}
&.selectTnCWrap .selectExstngAgrmnt .selectExstngAgrmnt-benefits li:last-child {
    margin-right: 0px;
}
&.selectTnCWrap .selectExstngAgrmnt .selectExstngAgrmnt-btns {
    margin-top: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
}
&.selectTnCWrap .selectExstngAgrmnt .selectExstngAgrmnt-btns .agreeStatement {
    margin-bottom: 24px;
    font-size: 16px;
    line-height: 26px;
    color: #4a4a4a;
    text-align: center;
}
&.selectTnCWrap .selectExstngAgrmnt .selectExstngAgrmnt-btns .agreeStatement a {
    line-height: 26px;
    text-decoration: underline;
}
&.selectTnCWrap .selectExstngAgrmnt .selectExstngAgrmnt-btns .enrollBenefitText {
    font-size: 16px;
    line-height: 26px;
    color: #000000;
}
&.selectTnCWrap .selectExstngAgrmnt .selectExstngAgrmnt-btns .enrollBenefitText a {
    font-size: 16px;
    line-height: 26px;
    color: #0091FF;
}
&.selectTnCWrap .selectExstngAgrmnt .continueBkngBtn {
    font-size: 20px;
    font-weight: 900;
    line-height: 16px;
    color: #0091FF;
    margin-top: 59px;
}
&.selectTnCWrap .selectExstngAgrmnt .newAgrmntSentEmail {
    font-size: 16px;
    color: #4a4a4a;
    text-align: center;
}

/* For mobile */

&.selectTnCWrap.mobile {
    padding: 26px 16px 40px;
    width: 100%;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0) 80.33%, #DED1F4 111.55%);
    border-radius: 0;
}
&.selectTnCWrap.navigationSec.mobile {
    background: none;
    height: 100vh;
}
&.selectTnCWrap.mobile .selectTnC-content {
    margin-top: 24px;
}
&.selectTnCWrap.mobile .heading {
    font-size: 24px;
    line-height: 28px;
}
&.selectTnCWrap.mobile .subHeading {
    line-height: 16px;
}
&.selectTnCWrap.mobile .selectTnC-content .exstngAgrmnt, &.selectTnCWrap.mobile .selectTnC-content .newAgrmnt {
    padding: 0 8px;
    margin-left: 0px;
}
&.selectTnCWrap.mobile .selectTnC-content .exstngAgrmnt {
    background: linear-gradient(180deg, #DFDFDF -17.11%, rgba(255, 255, 255, 0) 105.41%);
    border-radius: 8px 8px 0 0;
}
&.selectTnCWrap.mobile .selectTnC-content .newAgrmnt {
    border: none;
    background: linear-gradient(180deg, #C6FFC1 2.1%, rgba(255, 255, 255, 0) 120.47%);
    border-radius: 8px 8px 0 0;
    box-shadow: none;
}
&.selectTnCWrap.mobile .selectTnC-content .cardHeight .equalHeight {
    padding: 10px 0;
    font-size: 12px;
    border-bottom: 1px solid #DDDDDD;
}
&.selectTnCWrap.mobile .selectTnC-content .cardHeight p {
    padding: 6px 0;
    font-size: 12px;
}
&.selectTnCWrap.mobile .selectTnC-content .exstngAgrmntBtn {
    width: 100%;
    margin: 18px 0 0;
    font-size: 12px;
}
&.selectTnCWrap.mobile .primaryBtn {
    font-size: 12px;
    flex: 1;
}
&.selectTnCWrap.mobile .primaryBtn.newAgrmntBtn {
    margin: 18px 0 0;
    font-size: 12px;
    width: auto;
}
&.selectTnCWrap.mobile .selectExstngAgrmnt-btns .primaryBtn {
    font-weight: 700;
    margin-top: 0px;
    flex: none;
}
&.selectTnCWrap.mobile .tertiaryBtn {
    font-size: 12px;
    margin-right: 20px;
}
&.selectTnCWrap.mobile .selectTnC-content .newAgrmnt .infoTag {
    left: 8px;
}
&.selectTnCWrap .selectTnC-content .benefits {
    min-width: 115px;
}
&.selectTnCWrap.mobile .selectTnC-content .exstngAgrmnt .equalHeight {
    color: #9B9B9B;
}
&.selectTnCWrap.mobile .selectExstngAgrmnt .selectExstngAgrmnt-img {
    width: 61px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 26px;
}
&.selectTnCWrap.mobile .selectExstngAgrmnt {
    padding: 0 0 40px 10px;
    margin: 0 -5px 0 0;
    align-items: unset;
    height: auto;
}
&.selectTnCWrap.mobile .selectExstngAgrmnt .selectExstngAgrmnt-title {
    font-size: 20px;
    line-height: 24px;
    font-weight: 900;
    color: #000000;
    text-align: center;
    margin-bottom: 41px;
}
&.selectTnCWrap.mobile .selectExstngAgrmnt .benefitsTitle {
    margin-top: 48px;
    font-size: 14px;
    line-height: 18px;
    text-align: left;
}
&.selectTnCWrap.mobile .selectExstngAgrmnt .selectExstngAgrmnt-benefits {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
}
&.selectTnCWrap.mobile .selectExstngAgrmnt .selectExstngAgrmnt-benefits li {
    margin: 0 0 16px 0;
    max-width: 100%;
}
&.selectTnCWrap.mobile .selectExstngAgrmnt .selectExstngAgrmnt-benefits li:last-child {
    margin: 0px;
}
&.selectTnCWrap.mobile .selectExstngAgrmnt .selectExstngAgrmnt-btns .agreeStatement {
    margin-bottom: 41px;
    font-size: 12px;
    line-height: 20px;
    color: #4a4a4a;
    text-align: left;
}
&.selectTnCWrap.mobile .selectExstngAgrmnt .selectExstngAgrmnt-btns .agreeStatement a {
    line-height: 20px;
    font-size: 12px;
    text-decoration: none;
}
&.selectTnCWrap.mobile .selectExstngAgrmnt .selectExstngAgrmnt-btns .enrollBenefitText {
    font-size: 12px;
    line-height: 18px;
    color: #000000;
    width: 210px;
    text-align: center;
}
&.selectTnCWrap.mobile .selectExstngAgrmnt .selectExstngAgrmnt-btns .enrollBenefitText a {
    font-size: 12px;
    line-height: 18px;
    color: #0091FF;
}
&.selectTnCWrap.mobile .selectExstngAgrmnt .continueBkngBtn {
    font-size: 14px;
    font-weight: 900;
    line-height: 16px;
    color: #0091FF;
    margin-top: 157px;
    margin-bottom: 56px;
    width: 100%;
    text-align: center;
}
&.selectTnCWrap.mobile .selectExstngAgrmnt .newAgrmntSentEmail {
    font-size: 12px;
    color: #4a4a4a;
    text-align: center;
}
&.selectTnCWrap.mobile .selectExstngAgrmnt .newAgrmntSentEmail span {
    font-weight: 900;
}
.mobile .expiryInfo {
    font-size: 10px;
}
.margin-class {
  margin-bottom: 8% !important;
}
.container{
	max-width: 1200px;
	margin: 0 auto;
}

/* Sprite Icons */
.sprite{
	background: url(${agrmntSprite}) no-repeat; 
	display: inline-block; 
	background-size: 200px 200px; 
	font-size: 0px; 
	flex-shrink: 0;
}
.ic_my{
	width: 27px;
	height: 26px;
	background-position: -6px -6px;
}
.ic_tick{
	width: 32px;
	height: 32px;
	background-position: -68px -3px;
}
.ic_goldenArrow{
	width: 17px;
	height: 22px;
	background-position: -40px -9px;
}
.ic_heroText{
	width: 38px;
	height: 12px;
	background-position: -109px -6px;
}
.ic_goldCoinsText{
	width: 55px;
	height: 9px;
	background-position: -108px -25px;
}
.ic_deposit{
	width: 25px;
	height: 23px;
	background-position: -169px -5px;
}
.ic_notFound{
	width: 37px;
	height: 28px;
	background-position: -5px -49px;
}
.ic_graphDefault{
	width: 21px;
	height: 15px;
	background-position: -54px -42px;
}
.ic_graphActive{
	width: 21px;
	height: 15px;
	background-position: -54px -62px;
}
.ic_listDefault{
	width: 21px;
	height: 15px;
	background-position: -84px -42px;
}
.ic_listActive{
	width: 21px;
	height: 15px;
	background-position: -84px -62px;
}
.ic_support{
	width: 25px;
	height: 32px;
	background-position: -111px -41px;
}
.ic_cashback{
	width: 25px;
	height: 28px;
	background-position: -143px -42px;
}
.ic_onwayArrow{
	width: 9px;
	height: 4px;
	background-position: -20px -85px;
}
.ic_roundTripArrow{
	width: 9px;
	height: 8px;
	background-position: -5px -85px;
}
.ic_cap{
	width: 15px;
	height: 15px;
	background-position: -177px -41px;
}
.ic_grayInfo{
	width: 15px;
	height: 15px;
	background-position: -177px -59px;
}

/* Agreement Sprite */

.agrmntSprite {
	background: url(${agrmntSprite}) no-repeat; 
	display: inline-block; 
	background-size: 100px 100px; 
	font-size: 0px; 
	flex-shrink: 0;
}
.agrmntSprite--crossIcon {
	background-position: -3px -2px;
	width: 20px;
	height: 21px;
}
.agrmntSprite--tickIcon {
	background-position: -26px -2px;
	width: 21px;
	height: 21px;
}
.agrmntSprite--eye {
	background-position: -49px -2px;
	width: 22px;
	height: 14px;
}

/* Agreement Sprite End */

/* back arrow */
.backArrow {
	content: "";
    display: inline-flex;
    border: solid #000000;
    border-width: 0 2px 2px 0;
    padding: 3px;
    transform: rotate(135deg);
}
@charset "utf-8";
*,
*:before,
*:after {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  vertical-align: top;
  padding: 0;
  margin: 0;
  -webkit-font-smoothing: antialiased;
}
*:focus,
:click {
  outline: 0;
  border: none;
}
html,
body {
  padding: 0;
  margin: 0;
  color: #4a4a4a;
  font-size: 14px;
  font-family: 'Lato', sans-serif;
}
body{
  /* -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none; */
}
html {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
/* ::-webkit-scrollbar {
  display: none;
} */
body {
  background-color: #fff;
}
h1,
h2,
h3,
h4,
h5,
h6,
p,
ul {
  margin: 0;
  list-style: none;
}
a {
  color: #008cff;
  text-decoration: none;
  cursor: pointer;
}
img {
  max-width: 100%;
}
table{
  border-collapse: collapse;
}
a:hover,
a:focus {
  text-decoration: none;
  outline: none;
}
.hide {
  display: none;
}
.show {
  display: block;
}
.hidden {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.5s ease-in-out;
}
.visible {
  visibility: visible;
}
.fixed {
  position: fixed;
  width: 100%;
}
.bodyFixed {
  overflow: hidden;
}
.bodyStatic {
  position: static;
  overflow: visible;
  width: 100%;
}
.makeSticky {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 1;
}
.makeRelative {
  position: relative;
}
.makeAbsolute {
  position: absolute;
}
.clearFix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearFix {
  display: inline-block;
}

.truncate {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lineThrough {
  text-decoration: line-through;
}
.pointer{ cursor: pointer;}
.capText {
  text-transform: uppercase;
}
.fullWidth {
  width: 100%;
}

/* Margin Top */
.appendTop3 {
  margin-top: 3px;
}
.appendTop5 {
  margin-top: 5px;
}
.appendTop6 {
  margin-top: 6px;
}
.appendTop8 {
  margin-top: 8px;
}
.appendTop10 {
  margin-top: 10px;
}
.appendTop12 {
  margin-top: 12px;
}
.appendTop14 {
  margin-top: 14px;
}
.appendTop15 {
  margin-top: 15px;
}
.appendTop16 {
  margin-top: 16px;
}
.appendTop18 {
  margin-top: 18px;
}
.appendTop20 {
  margin-top: 20px;
}
.appendTop22 {
  margin-top: 22px;
}
.appendTop24 {
  margin-top: 24px;
}
.appendTop26 {
  margin-top: 26px;
}
.appendTop28 {
  margin-top: 28px;
}
.appendTop30 {
  margin-top: 30px;
}
.appendTop40 {
  margin-top: 40px;
}

/* Set Margins Right */
.appendRight3 {
  margin-right: 3px;
}
.appendRight5 {
  margin-right: 5px;
}
.appendRight6 {
  margin-right: 6px;
}
.appendRight8 {
  margin-right: 8px;
}
.appendRight10 {
  margin-right: 10px;
}
.appendRight12 {
  margin-right: 12px;
}
.appendRight14 {
  margin-right: 14px;
}
.appendRight15 {
  margin-right: 15px;
}
.appendRight16 {
  margin-right: 16px;
}
.appendRight18 {
  margin-right: 18px;
}
.appendRight20 {
  margin-right: 20px;
}
.appendRight22 {
  margin-right: 22px;
}
.appendRight24 {
  margin-right: 24px;
}
.appendRight26 {
  margin-right: 26px;
}
.appendRight28 {
  margin-right: 28px;
}
.appendRight30 {
  margin-right: 30px;
}

/* Margin Bottom */
.appendBottom2 {
  margin-bottom: 2px;
}
.appendBottom3 {
  margin-bottom: 3px;
}
.appendBottom4 {
  margin-bottom: 4px;
}
.appendBottom5 {
  margin-bottom: 5px;
}
.appendBottom6 {
  margin-bottom: 6px;
}
.appendBottom8 {
  margin-bottom: 8px;
}
.appendBottom10 {
  margin-bottom: 10px;
}
.appendBottom12 {
  margin-bottom: 12px;
}
.appendBottom14 {
  margin-bottom: 14px;
}
.appendBottom15 {
  margin-bottom: 15px;
}
.appendBottom16 {
  margin-bottom: 16px;
}
.appendBottom18 {
  margin-bottom: 18px;
}
.appendBottom20 {
  margin-bottom: 20px;
}
.appendBottom22 {
  margin-bottom: 22px;
}
.appendBottom24 {
  margin-bottom: 24px;
}
.appendBottom25 {
  margin-bottom: 25px;
}
.appendBottom30 {
  margin-bottom: 30px;
}
.appendBottom32 {
  margin-bottom: 32px;
}
.appendBottom40 {
  margin-bottom: 40px;
}
.appendBottom52 {
  margin-bottom: 52px;
}
.appendBottom56 {
  margin-bottom: 56px;
}
.appendBottom65 {
  margin-bottom: 65px;
}

/* Margin Left */
.appendLeft3 {
  margin-left: 3px;
}
.appendLeft5 {
  margin-left: 5px;
}
.appendLeft6 {
  margin-left: 6px;
}
.appendLeft8 {
  margin-left: 8px;
}
.appendLeft10 {
  margin-left: 10px;
}
.appendLeft12 {
  margin-left: 12px;
}
.appendLeft14 {
  margin-left: 14px;
}
.appendLeft15 {
  margin-left: 15px;
}
.appendLeft16 {
  margin-left: 16px;
}
.appendLeft18 {
  margin-left: 18px;
}
.appendLeft20 {
  margin-left: 20px;
}
.appendLeft22 {
  margin-left: 22px;
}
.appendLeft24 {
  margin-left: 24px;
}
.appendLeft26 {
  margin-left: 26px;
}
.appendLeft28 {
  margin-left: 28px;
}
.appendLeft30 {
  margin-left: 30px;
}

/* Margin All side */
.margin10 {
  margin: 10px;
}
.margin12 {
  margin: 12px;
}
.margin15 {
  margin: 15px;
}

/* Padding All Side */
.padding8 {
  padding: 8px;
}
.padding10 {
  padding: 10px;
}
.padding12 {
  padding: 12px;
}
.padding14 {
  padding: 14px;
}
.padding15 {
  padding: 15px;
}
.padding16 {
  padding: 16px;
}
.padding20 {
  padding: 20px;
}
.paddingLR10 {
  padding-left: 10px;
  padding-right: 10px;
}
.paddingLR12 {
  padding-left: 12px;
  padding-right: 12px;
}
.paddingLR15 {
  padding-left: 15px;
  padding-right: 15px;
}
.paddingLR16 {
  padding-left: 16px;
  padding-right: 16px;
}
.paddingLR20 {
  padding-left: 20px;
  padding-right: 20px;
}

.paddingTB2 {
  padding-top: 2px;
  padding-bottom: 2px;
}
.paddingTB10 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.paddingTB12 {
  padding-top: 12px;
  padding-bottom: 12px;
}
.paddingTB15 {
  padding-top: 15px;
  padding-bottom: 15px;
}
.paddingTB16 {
  padding-top: 16px;
  padding-bottom: 16px;
}
.paddingTB20 {
  padding-top: 20px;
  padding-bottom: 20px;
}
.boxPadding {
  padding: 20px;
}

/* Font Size */
.font8 {
  font-size: 8px;
  line-height: 10px;
}
.font9 {
  font-size: 9px;
  line-height: 11px;
}
.font10 {
  font-size: 10px;
  line-height: 12px;
}
.font11 {
  font-size: 11px;
  line-height: 13px;
}
.font12 {
  font-size: 12px;
  line-height: 14px;
}
.font13 {
  font-size: 13px;
  line-height: 15px;
}
.font14 {
  font-size: 14px;
  line-height: 16px;
}
.font15 {
  font-size: 15px;
  line-height: 17px;
}
.font16 {
  font-size: 16px;
  line-height: 18px;
}
.font18 {
  font-size: 18px;
  line-height: 20px;
}
.font20 {
  font-size: 20px;
  line-height: 22px;
}
.font22 {
  font-size: 22px;
  line-height: 24px;
}
.font24 {
  font-size: 24px;
  line-height: 26px;
}
.font26 {
  font-size: 26px;
  line-height: 28px;
}
.font28 {
  font-size: 28px;
  line-height: 30px;
}
.font30 {
  font-size: 30px;
  line-height: 32px;
}
.font36 {
  font-size: 36px;
  line-height: 38px;
}

/* Font Family */

.poppinsThin{font-weight: 100;}
.poppinsLight{font-weight: 300;}
.poppinsRegular{font-weight: 400;}
.poppinsMedium{font-weight: 500;}
.poppinsSemiBold{font-weight: 600;}
.poppinsBold{font-weight: 700;}
.poppinsExtraBold{font-weight: 800;}
.poppinsBlack{font-weight: 900;}

.latoRegular {font-weight: 400;}
.latoBold {font-weight: 700;}
.latoBlack {font-weight: 900;}

.lineHight16 {
  line-height: 16px !important;
}
.lineHight18 {
  line-height: 18px !important;
}
.lineHight20 {
  line-height: 20px !important;
}
.lineHight22 {
  line-height: 22px !important;
}
.lineHeight34 {
  line-height: 34px !important;
}

/* Font Color */

.blackText {
  color: #000;
}
.darkText {
  color: #4a4a4a;
}
.blueText {
  color: #008cff;
}
.greenText {
  color: #249995;
}
.redText {
  color: #eb2026;
}
.greyText {
  color: #9b9b9b;
}
.whiteText {
  color: #fff;
}
.orangeText {
  color: #f09819;
}

/* BG Color */
.greenBg {
  background-color: #249995;
}
.redBg {
  background-color: #d0021b;
}
.orangeBg {
  background-color: #f09819;
}

/* Alignment */

.textLeft {
  text-align: left;
}
.textRight {
  text-align: right;
}
.textCenter {
  text-align: center;
}

.bdrTop1 {
  border-top: 1px solid #e7e7e7;
}
.bdrBottom1 {
  border-bottom: 1px solid #e7e7e7;
}
.bdrBottom2 {
  border-bottom: solid 2px #e7e7e7;
}
.calc30 {
  width: calc(100% - 30px);
}
.calc40 {
  width: calc(100% - 40px);
}
.calc60 {
  width: calc(100% - 60px);
}
.calc80 {
  width: calc(100% - 80px);
}
.calc140 {
  width: calc(100% - 140px);
}
.width30 {
  width: 30%;
}
.width48 {
  width: 48%;
}
.width60 {
  width: 60%;
}
.width80 {
  width: 80%;
}
.width100 {
  width: 100%;
}
.width90px {
  width: 90px;
}
.width250px {
  width: 250px;
}
.width280px {
  width: 280px;
}
.marginAuto {
  margin-left: auto;
  margin-right: auto;
}
.makeFlex {
  display: flex;
}
.makeFlex.flexOne {
  flex: 1;
}
.makeFlex.flexWrap {
  flex-wrap: wrap;
}
.makeFlex.column {
  flex-direction: column;
}
.makeFlex.row {
  flex-direction: row;
}
.makeFlex.perfectCenter {
  align-items: center;
  justify-content: center;
}
.makeFlex.hrtlCenter {
  align-items: center;
}
.makeFlex.vrtlCenter {
  justify-content: center;
}
.makeFlex.spaceBetween {
  justify-content: space-between;
}
.makeFlex.spaceAround {
  justify-content: space-around;
}
.makeFlex.end {
  align-items: baseline;
}
.makeFlex.top {
  align-items: flex-start;
}
.makeFlex.right {
  align-items: flex-end;
}
.pushRight {
  margin-left: auto;
}
.pushLeft {
  margin-right: auto;
}
.inlineB {
  display: inline-block;
}
.flexOne {
  flex: 1;
}
.noShrink {
  flex-shrink: 0;
}
.inlineFlex {
  display: inline-flex;
}
.cursorPointer {
  cursor: pointer;
}
  `,
);
